import Swiper, {Lazy, Navigation, Pagination, Thumbs} from "swiper"

const videoSwiper = {

    init: () => {

        var swiper = new Swiper(".video-swiper-thumbs", {
            spaceBetween: 30,
            slideToClickedSlide: true,
            runCallbacksOnInit: false,
            breakpoints: {
                768 : {
                    slidesPerView: 2.5,
                },
                920 : {
                    slidesPerView: 3.5,
                },
                1024 : {
                    slidesPerView: 4.5,
                }
            }
        });
        var swiper2 = new Swiper(".video-swiper", {
            modules: [ Pagination, Lazy, Thumbs, Navigation ],
            watchOverflow: true,
            centeredSlides: true,
            spaceBetween: 10,
            slidesPerView: 1,
            resizeObserver: true,
            a11y: true,
            grabCursor: true,
            preloadImages: false,
            lazy: {
                loadPrevNext: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },


            thumbs: {
                swiper: swiper,
            },
        });

        var $numberSlides = swiper.slides.length;

        if($numberSlides > 0 && $numberSlides <= 1){
            var thumbs = document.getElementById('swiper-thumbs');
            thumbs.classList.add('d-none');
        }


    }
}

export default videoSwiper;
